import { useGetPurchaseOrderLinePriceChangesQuery } from "shared/redux/endpoints/procurementPurchases"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { formatVND, linePeriodLabel, LINE_PERIOD_COLOR } from "../../constants"

const diffColor = (d) => (d > 0 ? "var(--pc-danger, #b42318)" : d < 0 ? "var(--pc-success, #067647)" : undefined)

// What approving this PO does to its order lines: old → new unit price and amount per line.
const OrderLinePriceChanges = ({ purchaseId }) => {
  const { data, isFetching } = useGetPurchaseOrderLinePriceChangesQuery(purchaseId, { skip: !purchaseId })
  const lines = data?.lines || []
  if (isFetching && !data) return <MDTypography variant="caption" color="text">Checking order line prices…</MDTypography>
  if (!data || lines.length === 0) return null
  if (!data.ready) {
    return (
      <MDTypography variant="caption" color="text">
        The selected quote isn&apos;t fully priced yet, so the order line prices can&apos;t be previewed.
      </MDTypography>
    )
  }
  return (
    <MDBox>
      <MDTypography variant="button" fontWeight="medium" display="block" mb={0.5}>
        Order line prices after approval
      </MDTypography>
      <div className="pc-table-wrap" style={{ maxHeight: 260, overflow: "auto" }}>
        <table className="pc-table">
          <thead>
            <tr>
              <th>OR</th>
              <th>Item</th>
              <th>Month</th>
              <th className="pc-th-right">Qty</th>
              <th className="pc-th-right">Unit price</th>
              <th className="pc-th-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {lines.map((l) => (
              <tr key={l.orderRequestLineId}>
                <td>{l.orCode}</td>
                <td>{l.itemName}</td>
                <td style={{ whiteSpace: "nowrap", color: LINE_PERIOD_COLOR[l.period?.budgetStatus] }}>
                  {linePeriodLabel(l) || "—"}
                </td>
                <td className="pc-td-right">{l.quantity}</td>
                <td className="pc-td-right" style={{ whiteSpace: "nowrap" }}>
                  {formatVND(l.oldUnitPrice)} → <strong>{formatVND(l.newUnitPrice)}</strong>
                </td>
                <td className="pc-td-right" style={{ whiteSpace: "nowrap" }}>
                  {formatVND(l.oldAmount)} → <strong style={{ color: diffColor(l.difference) }}>{formatVND(l.newAmount)}</strong>
                </td>
              </tr>
            ))}
            <tr>
              <td className="pc-td-strong" colSpan={5}>
                Total
              </td>
              <td className="pc-td-right pc-td-strong" style={{ whiteSpace: "nowrap" }}>
                {formatVND(data.oldTotal)} → {formatVND(data.newTotal)}
                <div style={{ color: diffColor(data.difference), fontWeight: 400 }}>
                  {data.difference > 0 ? "+" : ""}
                  {formatVND(data.difference)}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </MDBox>
  )
}

export default OrderLinePriceChanges
